import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from "react-helmet-async";
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Terms and conditions for Rajput Shiksha Kosh, outlining the rules and regulations for donations and participation."
        />
      </Helmet>
    <section className="terms-and-conditions-wrapper">
      <div className="terms-and-conditions-container">
        
        {/* --- 1. HEADER (Title + Divider) --- */}
        <div className="terms-and-conditions-header">
          <h2 className="terms-and-conditions-title">TERMS & CONDITIONS</h2>
          <div className="terms-and-conditions-divider">
            <span className="terms-and-conditions-line"></span>
            <GiFairyWings className="terms-and-conditions-icon" />
            <span className="terms-and-conditions-line"></span>
          </div>
        </div>

        {/* --- 2. MAIN CONTENT DIV (White Background Card) --- */}
        <div className="terms-and-conditions-content-card">
          
          <h3 className="terms-and-conditions-sub-heading-line">
            राजपूत शिक्षा कोष - नियम एवं शर्तें
          </h3>
          
          <p className="terms-and-conditions-paragraph">
            <strong>राजपूत शिक्षा कोष</strong> की वेबसाइट पर आपका स्वागत है। इस वेबसाइट का उपयोग करने, दान (Donation) देने अथवा छात्रवृत्ति/प्रतिभा खोज परीक्षा के लिए आवेदन करने का अर्थ है कि आप ट्रस्ट द्वारा निर्धारित निम्नलिखित नियमों और शर्तों से पूरी तरह सहमत हैं। कृपया इन्हें ध्यानपूर्वक पढ़ें।
          </p>

          <h4 className="terms-and-conditions-section-title">1. दान (Donation) और स्थायी कोष (Corpus Fund) के नियम</h4>
          <ul className="terms-and-conditions-list">
            <li><strong>अहस्तांतरणीय और अहस्तांतरणीय (Non-Refundable):</strong> राजपूत शिक्षा कोष में दिया गया कोई भी दान पूरी तरह से स्वैच्छिक है। एक बार दान जमा हो जाने के बाद, किसी भी परिस्थिति में इसे वापस (Refund) नहीं किया जाएगा।</li>
            <li><strong>मूल कोष की सुरक्षा:</strong> दान की गई राशि ट्रस्ट के 10 करोड़ रुपये के स्थायी कोष (Corpus Fund) में जुड़ती है। नियम के अनुसार, इस मूल राशि में से एक भी रुपया कभी नहीं निकाला जाएगा।</li>
            <li><strong>ब्याज/लाभांश का उपयोग:</strong> दान की गई राशि से प्राप्त होने वाले ब्याज और लाभांश का उपयोग ही केवल समाज के अभावग्रस्त एवं प्रतिभावान छात्रों की छात्रवृत्ति और शिक्षा ऋण (Education Loan) के लिए किया जाएगा।</li>
          </ul>

          <h4 className="terms-and-conditions-section-title">2. छात्रवृत्ति एवं शिक्षा ऋण (Scholarship & Education Loan) की शर्तें</h4>
          <ul className="terms-and-conditions-list">
            <li><strong>चयन प्रक्रिया:</strong> छात्रवृत्ति या शिक्षा ऋण के लिए छात्रों का चयन 'माध्यमिक शिक्षा समिति' और 'उच्च शिक्षा समिति' की सिफारिशों और मेरिट (प्रतिभा खोज परीक्षा आदि) के आधार पर किया जाएगा।</li>
            <li><strong>पात्रता (Eligibility):</strong> आवेदन करने वाला छात्र राजपूत समाज का होना चाहिए एवं उसके परिवार की आर्थिक स्थिति ट्रस्ट द्वारा निर्धारित मापदंडों (जैसे- वार्षिक आय) के अंतर्गत होनी चाहिए।</li>
            <li><strong>अंतिम निर्णय:</strong> किसी भी छात्र को छात्रवृत्ति देना या न देना पूर्णतः ट्रस्ट की प्रबंध समिति (Trustee Board) के विशेषाधिकार में आता है। समिति का निर्णय अंतिम और सर्वमान्य होगा।</li>
          </ul>

          <h4 className="terms-and-conditions-section-title">3. पारदर्शिता और सार्वजनिक डेटा (Public Data Display)</h4>
          <p className="terms-and-conditions-paragraph">
            जैसा कि हमारी गोपनीयता नीति में उल्लेखित है, ट्रस्ट पूर्ण पारदर्शिता के सिद्धांत पर काम करता है। वेबसाइट का उपयोग करने और दान देने/छात्रवृत्ति प्राप्त करने पर, आप सहमत हैं कि:
          </p>
          <ul className="terms-and-conditions-list">
            <li>आपका नाम, दान की गई राशि, और भुगतान का माध्यम वेबसाइट की <strong>'दानदाता सूची' (Donor's List)</strong> में सार्वजनिक रूप से प्रदर्शित किया जाएगा।</li>
            <li>छात्रवृत्ति प्राप्त करने वाले छात्रों का विवरण वेबसाइट की <strong>'छात्रवृत्ति सूची' (Scholar's List)</strong> में पारदर्शिता हेतु प्रदर्शित किया जाएगा।</li>
          </ul>

          <h4 className="terms-and-conditions-section-title">4. वेबसाइट का उपयोग एवं जानकारी की सटीकता</h4>
          <ul className="terms-and-conditions-list">
            <li><strong>सही जानकारी प्रस्तुत करना:</strong> परीक्षा फॉर्म, छात्रवृत्ति फॉर्म या दान करते समय आपके द्वारा दी गई सभी जानकारी (नाम, पता, संपर्क नंबर आदि) पूर्णतः सत्य और सटीक होनी चाहिए।</li>
            <li><strong>दस्तावेज़ों का सत्यापन:</strong> यदि किसी छात्र द्वारा दी गई जानकारी या दस्तावेज़ (आय प्रमाण पत्र, मार्कशीट आदि) गलत या फर्जी पाए जाते हैं, तो उसकी छात्रवृत्ति तुरंत रद्द कर दी जाएगी एवं कानूनी कार्यवाही की जा सकती है।</li>
            <li>वेबसाइट की सामग्री, लोगो और डिज़ाइन राजपूत शिक्षा कोष की बौद्धिक संपदा (Intellectual Property) हैं। बिना पूर्व अनुमति के इनका व्यावसायिक उपयोग वर्जित है।</li>
          </ul>

          <h4 className="terms-and-conditions-section-title">5. क्षेत्राधिकार (Jurisdiction)</h4>
          <p className="terms-and-conditions-paragraph">
            राजपूत शिक्षा कोष एक पंजीकृत सार्वजनिक ट्रस्ट है। इस ट्रस्ट या वेबसाइट से संबंधित किसी भी प्रकार के कानूनी विवाद की स्थिति में, न्याय क्षेत्र केवल <strong>जोधपुर, राजस्थान (भारत)</strong> के न्यायालयों के अधीन होगा।
          </p>

          <p className="terms-and-conditions-blessing">
            "नियम समाज को व्यवस्थित करते हैं, और आपका सहयोग समाज को सशक्त।"
          </p>

          {/* --- SIGNATURE / CONTACT INFO --- */}
          <div className="terms-and-conditions-footer-sig">
            <h4>राजपूत शिक्षा कोष</h4>
            <p><strong>प्रबंध समिति (Trustee Board)</strong></p>
            <p>मारवाड़ राजपूत सभा भवन, पावटा 'बी' रोड, जोधपुर (राज.)</p>
            <p><strong>संपर्क:</strong> rajputshikshakosh@gmail.com</p>
          </div>
        </div>

      </div>
    </section>
    </>
  );
};

export default TermsAndConditions;